import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1270f452"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("circle", {
  cx: "50",
  cy: "50",
  r: "40",
  stroke: "black",
  fill: "none"
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "10",
  y1: "50",
  x2: "90",
  y2: "50",
  stroke: "black"
}, null, -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("line", {
  x1: "50",
  y1: "10",
  x2: "50",
  y2: "90",
  stroke: "black"
}, null, -1));
const _hoisted_5 = {
  key: 0,
  d: "M50,50 L50,10 A40,40 0 0,0 10,50 Z",
  fill: "black"
};
const _hoisted_6 = {
  key: 1,
  d: "M50,50 L50,10 A40,40 0 0,1 90,50 Z",
  fill: "black"
};
const _hoisted_7 = {
  key: 2,
  d: "M50,50 L50,90 A40,40 0 0,1 10,50 Z",
  fill: "black"
};
const _hoisted_8 = {
  key: 3,
  d: "M50,50 L50,90 A40,40 0 0,0 90,50 Z",
  fill: "black"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [_hoisted_2, _hoisted_3, _hoisted_4, $props.path.charAt(0) == '1' ? (_openBlock(), _createElementBlock("path", _hoisted_5)) : _createCommentVNode("", true), $props.path.charAt(1) == '1' ? (_openBlock(), _createElementBlock("path", _hoisted_6)) : _createCommentVNode("", true), $props.path.charAt(2) == '1' ? (_openBlock(), _createElementBlock("path", _hoisted_7)) : _createCommentVNode("", true), $props.path.charAt(3) == '1' ? (_openBlock(), _createElementBlock("path", _hoisted_8)) : _createCommentVNode("", true)]);
}